import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { DatePicker } from "@material-ui/pickers";
import { Box } from "@material-ui/core";
import { DATE_APP_FORMAT } from "constants/dateFormats";
import SrLabel from "../SrLabel";

const SrDatePicker = ({ label, name, ...props }) => {
  const intl = useIntl();
  return (
    <>
      {label && <SrLabel name={name}>{label}</SrLabel>}
      <Box mt={label ? 1 : ""}>
        <DatePicker
          inputVariant="outlined"
          format={DATE_APP_FORMAT}
          okLabel={intl.formatMessage({ id: "common.accept" })}
          cancelLabel={intl.formatMessage({ id: "common.cancel" })}
          {...props}
        />
      </Box>
    </>
  );
};

SrDatePicker.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
};

SrDatePicker.defaultProps = {
  label: null,
};

export default SrDatePicker;
